import ReactDOM from 'react-dom/client';

import App from './App';
import configureStore from './redux/store';

const { store } = configureStore();

const rootEl = document.getElementById('root');

if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App store={store} />);
}

if (module.hot) {
  module.hot.accept('./App', () => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const NextApp = require('./App').default;
    if (rootEl) {
      ReactDOM.createRoot(rootEl).render(<NextApp store={store} />);
    }
  });
}
